export default __webpack_public_path__ + "static/AppFace2-ffd34eaf6640f28fbb323d46e31380fb.png";